// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1uQbz","dragIcon":"SortableItem_dragIcon__346dj","disabled":"SortableItem_disabled__1TbKq"};